import { inject } from "@angular/core";
import { Tool } from "@aws-sdk/client-bedrock-runtime";
import { ManufacturingOrderService } from "../../../07_feature/manufacturing-order/manufacturing-order.service";
import { CreateOrderCompactComponent } from "../create-order-compact/create-order-compact.component";
import { AIComponentMessage } from "../../../03_model/ai-chat-message.model";
import { AITool } from "../../../03_model/ai-tool.interface";

export class CreateOrderTool implements AITool {

  tool_name = 'create_order';
  orderService = inject(ManufacturingOrderService);

  description = <Tool>{
    "toolSpec": {
      "name": this.tool_name,
      "description": "Open a dialog to create a new manufacturing order in the database. The name can be optionally provided and is not required, since the user can set it later.",
      "inputSchema": {
        "json": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "description": "The name of the manufacturing order to create in the database. This is optional and can be left blank."
            },
            "customerID": {
              "type": "string",
              "description": "The ID of the customer for whom the manufacturing order is being created. This is required. Ask the user for the name of the customer if you don't have it. Look the ID up in the database using the customer search."
            }
          },
          "required": [
            "customerID",
          ]
        }
      }
    }
  };

  async invoke({customerID, name}: {customerID?: string, name?: string}): Promise<AIComponentMessage> {
    return {
      type: 'component',
      role: 'user',
      component: CreateOrderCompactComponent,
      data: { customerID: customerID || '', name: name || '', submissionState: 'idle', errorMessage: null },
      contentForLLM: `Tool result: Displaying a form to let the user create a new manufacturing order.`,
      requiresFollowUp: false,
    };
  }
}
